import { Component } from '@angular/core';
import { MenuItem, ConfirmationService } from 'primeng/api';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { layoutConfig, LayoutService } from '../service/layout.service';
import { UserIdentityService } from '@shared/core/user-identity.service';
import { IntrojsService } from '../service/introjs.service';
import { SharedModule } from '@shared/shared.module';
import { Resources } from '@shared/model/permissions';
import { User } from '@shared/model/user';
import { AppLayout } from './app.layout';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator,SharedModule],
    templateUrl: "./app.topbar.html"
})
export class AppTopbar {
    items!: MenuItem[];
    config!: layoutConfig;
    logoRouterLink: string = "/mytasks"

    tenantName!: string;
    displayName!:string;
    hasMultiTenant: boolean=false;
    isTopbarMenuOpen: boolean = false;

    constructor(
        public appLayout:AppLayout,
        public layoutService: LayoutService,
        private userIdentityService: UserIdentityService,
        private introService: IntrojsService,
        private router: Router,
        private confirmationService: ConfirmationService
    ) {
        this.userIdentityService.currentPermissionUpdate$
        .subscribe((permissions) => {
            var resourceItem = this.userIdentityService.currentPermissionValue?.find(a => a.resource == Resources.Dashboard);
            if (!!resourceItem) {
                this.logoRouterLink = "/dashboard";
            }
        });

    }
    ngOnInit(){
        this.config = this.layoutService.layoutConfig();
    }
    ngAfterViewInit(): void {
        this.userIdentityService.currentUserUpdate$
            .subscribe((user: User|null) => {

                this.displayName = user?.displayName??"";
                this.tenantName = user?.tenantName??"";
                this.hasMultiTenant = !!user?.tenants;
                console.log('introService welcome');
                // This should be run after view init and user logs in 
                if (user?.tenantStatus=='Active') {
                    this.introService.welcome(this.appLayout);
                }
            });

    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
    toggleTopbarMenu() {
        this.isTopbarMenuOpen = !this.isTopbarMenuOpen;
    }
    closeTopbarMenu() {
        this.isTopbarMenuOpen = false;
    }
    onLogOffButtonClick(event:any) {
        event.preventDefault();
        this.confirmationService.confirm({
            message: 'Are you sure you want to log out?',
            header: 'Confirm Logout',
            icon: 'pi pi-exclamation-triangle',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                this.router.navigate(['/auth/login']);
            }
        });
    }
}
